// The configurator shows one section at a time (see useSectionAnimation), and sections can be taller than the
// viewport. TrackWrapper's default 0.5 threshold is unreachable for tall sections, so their "viewed" event never
// fires. A low threshold reliably captures the single on-screen section without over-firing.
export const SECTION_VIEW_THRESHOLD = 0.1;
